const iconsPath = `/wp-content/themes/JointsWP/assets/icons`;
const imagesPath = `/wp-content/themes/JointsWP/assets/images`;

// When adding / removing icons please also add / remove them in IIcons in index.interface
export default {
  academyHome: `${iconsPath}/home.svg`,
  academyLearning: `${iconsPath}/lernen.svg`,
  academyLearningDark: `${iconsPath}/lernen-dark.svg`,
  alert: `${iconsPath}/alert.svg`,
  alertGreen: `${iconsPath}/alert-green.svg`,
  alertRed: `${iconsPath}/alert-red.svg`,
  alertYellow: `${iconsPath}/alert-yellow.svg`,
  anchorDownBoldGreen: `${iconsPath}/anchor-down-bold-green.svg`,
  anchorDownBoldRed: `${iconsPath}/anchor-down-bold-red.svg`,
  anchorDownLeftBold: `${iconsPath}/arrow_down-left_bold.svg`,
  anchorDownRightBold: `${iconsPath}/arrow_down-right_bold.svg`,
  announcementBarInfoI: `${iconsPath}/announcement-bar-info-i.svg`,
  arrow: `${iconsPath}/arrow.svg`,
  arrowDown: `${iconsPath}/arrowDown.svg`,
  arrowRightWild: `${iconsPath}/arrow-right-wild.svg`,
  arrowRightWildWhite: `${iconsPath}/arrow-right-wild-white.svg`,
  blogNaviOverview: `${imagesPath}/blog-navi-overview.svg`,
  calendarDark: `${iconsPath}/calendar-dark.svg`,
  cartIcon: `${imagesPath}/bag.svg`,
  cartIconAdaptive: `${imagesPath}/bag-adaptive.svg`,
  checkboxEmpty: `${iconsPath}/checkbox-empty.svg`,
  checkboxFull: `${iconsPath}/checkbox-full.svg`,
  checkmark: `${imagesPath}/checkmark.svg`,
  christmasCalendar: {
    close: `${iconsPath}/christmas-calendar/close.svg`,
    present: `${iconsPath}/christmas-calendar/present.svg`,
  },
  close: `${iconsPath}/close.svg`,
  closeIcon: `${imagesPath}/x-white.svg`,
  customerTransfer: `${iconsPath}/customer-transfer.svg`,
  dashboard: `${iconsPath}/dashboard_black.svg`,
  dashboardWhite: `${iconsPath}/dashboard-white.svg`,
  dataSheet: `${iconsPath}/datasheet.svg`,
  download: `${imagesPath}/download.svg`,
  edit: `${iconsPath}/edit.svg`,
  euro: `${imagesPath}/euro-black.svg`,
  events: {
    date: `${iconsPath}/events/date.svg`,
    location: `${iconsPath}/events/location.svg`,
    orderAscending: `${iconsPath}/events/order-ascending.svg`,
    orderDescending: `${iconsPath}/events/order-descending.svg`,
    search: `${iconsPath}/events/search.svg`,
  },
  externalLink: `${iconsPath}/external-link.svg`,
  facebookIcon: `${imagesPath}/fb-full-white.svg`,
  frontpage: {
    quickLinks: {
      // icons will be displayed in quickLinks in THIS ORDER!
      /* eslint-disable sort-keys */
      smiley: `${imagesPath}/smiley.png`,
      world: `${imagesPath}/world.svg`,
      plant: `${imagesPath}/plant.svg`,
      present: `${imagesPath}/present.svg`,
      /* eslint-enable */
    },
    socialMedia: {
      facebook: `${iconsPath}/facebook_button.svg`,
      instagram: `${iconsPath}/instagram_button.svg`,
      pinterest: `${iconsPath}/pinterest_button.svg`,
      youtube: `${iconsPath}/youtube_button.svg`,
    },
  },
  generations: `${iconsPath}/generationen.svg`,
  grid: `${imagesPath}/kacheln-schwarz.svg`,
  help: `${iconsPath}/help.png`,
  human: `${iconsPath}/human.svg`,
  humanGrayIcon: `${imagesPath}/human-gray.svg`,
  humanIcon: `${imagesPath}/human.svg`,
  info: `${iconsPath}/info.svg`,
  instagramIcon: `${imagesPath}/instagram-white.svg`,
  invoiceDetails: `${iconsPath}/invoice-details.svg`,
  invoiceNotIncluded: `${iconsPath}/invoiceNotIncluded.svg`,
  invoicePayed: `${iconsPath}/invoicePayed.svg`,
  invoicePayment: `${iconsPath}/invoice-payment.svg`,
  leftArrow: `${imagesPath}/arrow-left.svg`,
  leftArrowWhite: `${imagesPath}/arrow-left-white.svg`,
  letterWhiteIcon: `${imagesPath}/letter-white.svg`,
  limitingActiveCart: `${iconsPath}/active-cart.svg`,
  limitingCartDisabled: `${iconsPath}/cart-disabled.svg`,
  limitingCartDisabledWhite: `${iconsPath}/cart-disabled-white.svg`,
  limitingFifteenMinutes: `${iconsPath}/fifteen-minutes.svg`,
  limitingStayActive: `${iconsPath}/stay-active.svg`,
  list: `${imagesPath}/liste-schwarz.svg`,
  live: {
    calendar: `${iconsPath}/live/calendar.svg`,
    cam: `${iconsPath}/live/cam.svg`,
    chat: `${iconsPath}/live/chat.svg`,
    clock: `${iconsPath}/live/clock.svg`,
    share: `${iconsPath}/live/share.svg`,
  },
  logos: {
    climateNeutral: `${imagesPath}/logo-climate-neutral.svg`,
    klimaschutzpreis: `${imagesPath}/logo-klimaschutzpreis.svg`,
  },
  mail: `${iconsPath}/mail.svg`,
  medal: `${iconsPath}/medal.svg`,
  minus: `${iconsPath}/minus.svg`,
  newFacebook: `${iconsPath}/new-facebook-icon.svg`,
  newInstagram: `${iconsPath}/new-instagram-icon.svg`,
  noTeam: `${iconsPath}/no-team.svg`,
  package: `${iconsPath}/package.svg`,
  parcel: `${iconsPath}/parcel.svg`,
  partner2: `${iconsPath}/partner-2.svg`,
  payment: {
    applepay: `${iconsPath}/apple-pay.svg`,
    eps: `${iconsPath}/eps.svg`,
    giroPay: `${iconsPath}/giro-pay.svg`,
    mastercard: `${iconsPath}/mastercard.svg`,
    paypal: `${iconsPath}/paypal.svg`,
    sofortueberweisung: `${iconsPath}/sofortueberweisung.svg`,
    visa: `${iconsPath}/visa.svg`,
  },
  phone: `${iconsPath}/phone.svg`,
  plus: `${iconsPath}/plus-bold.svg`,
  plusAdaptive: `${iconsPath}/plus-adaptive.svg`,
  plusLight: `${iconsPath}/plus-light.svg`,
  present: `${iconsPath}/present.svg`,
  print: `${iconsPath}/print.svg`,
  rightArrow: `${imagesPath}/arrow-right.svg`,
  rightArrowWhite: `${imagesPath}/arrow-right-white.svg`,
  ringanaBlumeBlack: `${iconsPath}/ringana-blume-black.svg`,
  ringanaBlumeWhite: `${iconsPath}/ringana-blume-white.svg`,
  ringanaLogo: `${imagesPath}/logo.svg`,
  ringanaLogoPartner: `${iconsPath}/logo_partner.svg`,
  ringanaValues: {
    anchorDownAnimation: `${iconsPath}/scroll-down-motion.gif`,
    anchorDownLeft: `${iconsPath}/anchor-down-left-bold.svg`,
    anchorDownRight: `${iconsPath}/anchor-down-right-bold.svg`,
    check: `${iconsPath}/check.svg`,
    dna: `${imagesPath}/RNG_values_dna.html`,
    excellence: `${imagesPath}/RNG_values_excellence.html`,
    fresh: `${imagesPath}/RNG_values_fresh.html`,
    headlineImg: `${imagesPath}/RNG_values_logo.html`,
    trendsetting: `${imagesPath}/RNG_values_trendsetting.html`,
    valuesIcon: `${iconsPath}/values-icon.svg`,
  },
  salestool: `${iconsPath}/salestool.svg`,
  search: `${iconsPath}/search.svg`,
  searchIcon: `${imagesPath}/search.svg`,
  searchWhite: `${iconsPath}/search-white.svg`,
  shoppingCart: `${iconsPath}/shopping_icon.svg`,
  shoppingCartMobile: `${iconsPath}/shopping_icon_mobil.svg`,
  smiley: `${iconsPath}/smiley.svg`,
  star: `${iconsPath}/star.svg`,
  suggestAsPartner: `${iconsPath}/suggest-as-partner.svg`,
  summitPalmDark: `${iconsPath}/summit-palm-dark.svg`,
  summits: {
    arrow: `${iconsPath}/summits/arrow.svg`,
    chevronLeft: `${iconsPath}/summits/chevron-left.svg`,
    chevronRight: `${iconsPath}/summits/chevron-right.svg`,
    circleCheck: `${iconsPath}/summits/circle-check.svg`,
    circleX: `${iconsPath}/summits/circle-x.svg`,
  },
  tick: `${iconsPath}/tick.svg`,
  truck: `${iconsPath}/truck.svg`,
  update: `${iconsPath}/update.svg`,
  vegan: `${iconsPath}/vegan.svg`,
  wallet: `${iconsPath}/wallet.svg`,
  x: `${iconsPath}/x.svg`,
  xLight: `${iconsPath}/x-light.svg`,
  xPink: `${iconsPath}/x-pink.svg`,
};
